import { CustomerInvoicesFilter } from '../shared/models/customer-invoices-filter';
import { CustomerPurchasesSummary } from '../shared/models';
import { CustomersService } from '../shared/services';
import { Component, ViewChild, OnInit } from '@angular/core';
import { TopLevelComponent, HeaderAction, GeneralFilter } from '../../shared/models';
import { AppPageComponent, FilterSheetComponent, RibbonMessageComponent } from '../../shared/ui';
import { Store, StoreHelper, UserService } from '../../shared/services';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'customers-search',
    template: require('./customers-search.component.pug')
})
export class CustomersSearchComponent extends TopLevelComponent implements OnInit {
    @ViewChild(AppPageComponent) appPage;
    @ViewChild(FilterSheetComponent) filterSheet;

    fg = new FormGroup({});
    purchases: Array<CustomerPurchasesSummary>;

    selectedSummary: CustomerPurchasesSummary;
    showCustomerDetails = false;
    loading = true;
    authorized = true;

    private _searchAction = { id: 'search', icon: 'search' };
    private _filterReady: boolean = false;
    private _filter: GeneralFilter;

    constructor(
        store: Store,
        storeHelper: StoreHelper,
        userService: UserService,
        private _customerService: CustomersService) {
        super(store, storeHelper, userService);
    }

    ngOnInit() {
        // set title and actions
        this.headerTitle = 'Customers';
        this.headerActions = [this._searchAction];
        this.subscribeToHeaderActions(this._reactToHeaderAction);
    }

    onFilterChanged(filter: GeneralFilter) {
        this._filter = filter;

        if (this._filter.locationsSelection.locations.length > 0) {

            this._loadPurchases();

        } else {

            this._resetCustomerData();
            this.empty = true;
            setTimeout(() => this.filterSheet.toggle(), 1500);

            if (this._filterReady) {
                this.filterSheet.toggle();
            }
            this._filterReady = true;
        }
    }

    showInvoices(purchaseSummary: CustomerPurchasesSummary) {
        if (purchaseSummary.invoiceCount === 0) {
            return;
        }

        let filter = new CustomerInvoicesFilter(this._filter.date, this._filter.locationsSelection, purchaseSummary);

        this.storeHelper.update('customerInvoicesFilter', filter);
        this.selectedSummary = purchaseSummary;
        this.showCustomerDetails = true;
    }

    coverClosed() {
        this.showCustomerDetails = false;
    }

    private _reactToHeaderAction(action: HeaderAction) {
        if (action.id === this._searchAction.id && this.authorized) {
            this.filterSheet.toggle();
        }
    }

    private _loadPurchases() {
        let that = this;
        this.empty = false;
        this.appPage.activatePreloader();
        
        this.loading = true;
        this._customerService.getPurchasesSummary(this._filter)
            .subscribe(purchases => {
                this.purchases = purchases;
                this.appPage.deactivatePreloader();
                this.empty = purchases.length < 1;

                if (this.empty) {
                    setTimeout(() => this.filterSheet.toggle(), 2000);
                }
            }, 
            err => {
                this.authorized = this.userService.userHasAccess(err);
                this.appPage.deactivatePreloader();
                this.loading = false;
            },
            () => that.loading = false);

        if (this._filterReady) {
            this.filterSheet.toggle();
        }

        this._filterReady = true;
    }

    private _resetCustomerData() {
        this.purchases = [];
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/customers/customers-search/customers-search.component.ts